import { render, staticRenderFns } from "./TabActions.vue?vue&type=template&id=2813377e&scoped=true&"
import script from "./TabActions.vue?vue&type=script&lang=js&"
export * from "./TabActions.vue?vue&type=script&lang=js&"
import style0 from "./TabActions.vue?vue&type=style&index=0&id=2813377e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813377e",
  null
  
)

export default component.exports